import { render } from "./company-registered-personnel.vue?vue&type=template&id=595e3e50&scoped=true"
import script from "./company-registered-personnel.vue?vue&type=script&lang=js"
export * from "./company-registered-personnel.vue?vue&type=script&lang=js"

import "./company-registered-personnel.vue?vue&type=style&index=0&id=595e3e50&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595e3e50"]])

export default __exports__